import React, { useState, useEffect } from 'react'

import { useTranslation } from "react-i18next";

import { BsPlusCircle, BsDashCircle, BsTrash } from "react-icons/bs";

import { useConfig } from '../../../contexts/ConfigContext';

import { useProduct } from '../../../contexts/ProductContext'

import { useCart } from '../../../contexts/CartContext'

import { ProductDetailView } from '../../ProductDetailView'

import { Modal } from '../../Shared/Modal'

import { Button } from '../../Shared/Buttons';

import { useTheme } from '../../../contexts/ThemeContext'

import { parseVariantIds, getMaxCartQuantity } from '../../../utils/productPricing'
import { formatPrice } from '../../../utils/formatPrice'

import {
  CartItemContainer,
  ItemImg,

  ItemDetail,

  DetailRow,

  ItemTitle,

  ItemPrice,

  ItemCountControll,

  ItemCount,

  RemoveIcon,

  RemoveText,

  ActionGroup,

  RemoveProductModalWrapper,

  ItemNote,

} from './styles'

export const CartItem = (props) => {



  const { item } = props

  const { t } = useTranslation();

  const [configState] = useConfig()

  const [cartCount, setCartCount] = useState(item.count)

  const [isModal, setIsModal] = useState(false)

  const [prodId, setProdId] = useState(null);

  const currentLng = localStorage.getItem('i18nextLng');

  const [products] = useProduct();

  const [theme] = useTheme()

  const [cart, { updateItem, removeItem, decreaseItem, currentVendorId }] = useCart();

  const prod = products.find(obj => obj.id === item.prodId)

  const itemName = currentLng === 'en'

    ? (item.name_en || prod?.name_en)

    : (item.name_ar || prod?.name_ar)

  const itemPrice = item.price ?? prod?.sale_price ?? prod?.price

  const itemImage = item.image || prod?.image

  const variantIds = parseVariantIds(item.variant_combination)

  const maxCount = getMaxCartQuantity(prod, variantIds)

  const canIncrease = maxCount == null || cartCount < maxCount

  const decreaseCartItem = () => {

    if (cartCount > 1) {

      decreaseItem(item.cartId);

      return;

    }

    setIsModal(true)

  }

  const increaseCartItem = () => {

    if (!canIncrease) return

    updateItem(item.cartId, cartCount + 1)

  }



  const removeCartItem = () => {

    setIsModal(true)

  }



  const prodViewHandleClick = (id) => {

    setProdId(id)

  }

  const prodCloseHandleClick = () => {

    setProdId(null)

  }



  useEffect(() => {

    const matchedProd = cart.find(obj => obj.cartId === item.cartId);

    if (matchedProd) setCartCount(matchedProd.count);

  }, [cart, item.cartId])



  const removeProductModal = (

    <RemoveProductModalWrapper>

      <RemoveIcon>

        <BsTrash color="#b50000" size="50" />

      </RemoveIcon>

      <RemoveText>{t('Are you sure to delete this item from the cart')}</RemoveText>

      <ActionGroup>

        <Button color="primary" width="100px" onClick={() => removeItem(item.cartId)}>

          {t('Yes')}

        </Button>

        <Button width="100px" onClick={() => setIsModal(false)} outLine>

          {t('No')}

        </Button>

      </ActionGroup>

    </RemoveProductModalWrapper>

  )

  return (

    <>

      <CartItemContainer>

        {itemImage && (

          <ItemImg

            src={itemImage}

            alt={itemName}

            onClick={() => prodViewHandleClick(item.prodId)}

          />

        )}

        <ItemDetail>

          <DetailRow>

            <ItemTitle onClick={() => prodViewHandleClick(item.prodId)}>

              {itemName}

            </ItemTitle>

            <ItemPrice>

              {`${formatPrice(itemPrice)} ${t(configState?.configs?.currency)}`}

            </ItemPrice>

          </DetailRow>

          {item.note && <ItemNote>{item.note}</ItemNote>}

          <DetailRow>

            <ItemCountControll>

              <BsDashCircle size="25" onClick={decreaseCartItem} />

              <ItemCount>{cartCount}</ItemCount>

              <BsPlusCircle
                size="25"
                color={canIncrease ? theme.colors?.primaryIconCol : theme.colors?.primaryDisabledCol}
                onClick={increaseCartItem}
              />

            </ItemCountControll>

            <BsTrash color="#b50000" size="22" onClick={removeCartItem} />

          </DetailRow>

        </ItemDetail>



        {prodId &&

          <ProductDetailView

            prodCloseHandleClick={prodCloseHandleClick}

            prodId={prodId}

            vendorId={currentVendorId}

          />

        }

      </CartItemContainer>

      <Modal

        open={isModal}

        children={removeProductModal}

        onClose={() => setIsModal(false)}

        width='400px'

        isHideCloseIcon

      />

    </>



  )

}

